// Read a same-origin path from ?next= so login can send the user back to where
// they came from (e.g. the "Connect with AINA Suite" consent screen).
// Anything that could leave the site (//evil.com, /\evil.com, https://...) is rejected.
export function getSafeNext(search) {
  const next = new URLSearchParams(search).get('next');
  if (!next || !next.startsWith('/') || next.startsWith('//') || next.startsWith('/\\')) return null;
  return next;
}
